module.exports = __webpack_public_path__ + "img/aston+martin.85c5ded3.png";